const navigationItemReferences = {
	groupNavItemIndex: 7,
	roleNavItemIndex: 8,
	organizationNavItemIndex: 5,
	pluginNavItemIndex: 10,
	navItemIndexToNavItemIdOffset: 2
} as const;

export default navigationItemReferences;
